import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { badgeHistoryEntityName } from '../entities/BadgeHistoryEntityTypes';
export function createBadgeHistoryEntry(context, { badgeId, createdBy, createdByEmail, createdByRole, action, accountBadgeIds, accountBadgeNames, note }) {
    const badgeHistoryStorage = context.storage(badgeHistoryEntityName);
    const accountsStorage = context.storage(accountEntityName);
    if (!createdByEmail || !createdByRole) {
        const account = accountsStorage.get(createdBy);
        createdByEmail = account.columns.email;
        createdByRole = account.columns.systemRole;
    }
    badgeHistoryStorage.post({
        action: 'create',
        data: {
            badgeId,
            action,
            note,
            createdByEmail,
            createdByRole,
            accountBadgeIds,
            accountBadgeNames,
            createdAt: Date.now(),
        },
    });
}
